import { createFileRoute } from "@tanstack/react-router";
import { lazy, Suspense } from "react";
import Layout from "@/components/layout/Layout";

const InstallPage = lazy(() => import("@/pages/InstallPage"));

export const Route = createFileRoute("/install/")({
  component: InstallRoute,
});

function InstallRoute() {
  return (
    <Layout>
      <Suspense fallback={null}>
        <InstallPage />
      </Suspense>
    </Layout>
  );
}
